export class SearchOrder {
  public columnName: string;
  public ascending: boolean | string;
}
